// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__5dSy0"};